export default __webpack_public_path__ + "static/media/blob4.84f19eff.svg";